module.exports = __webpack_public_path__ + "img/oshan_ari.304912b2.png";